import { useState } from 'react';

export default function FAQSection() {
  const faqs = [
    {
      q: '极速影视真的免费吗？需要注册吗？',
      a: '极速影视完全免费，无需注册即可在线观看所有内容。我们坚持免费看全集理念，用户打开网站就能直接追剧，没有任何隐藏收费或会员门槛。注册账号后可以享受收藏、历史记录、弹幕互动等进阶功能，但不注册也不影响观看体验。',
    },
    {
      q: '播放会不会卡顿？画质怎么样？',
      a: '极速影视采用自研智能CDN加速技术，全国部署300+分发节点，确保极速不缓冲的流畅播放体验。平台支持1080P和4K超清画质，根据您的网络状况自动选择最佳清晰度。99.9%的用户反馈播放流畅不卡顿，秒开即播是我们对品质的底线要求。',
    },
    {
      q: '支持哪些设备观看？可以投屏吗？',
      a: '极速影视全面支持PC浏览器、iOS和Android手机APP、平板电脑以及智能电视。手机端支持DLNA和AirPlay投屏功能，一键将内容投到大屏幕观看。所有设备间无缝同步观看进度，换设备继续看。',
    },
    {
      q: '内容更新频率如何？会有新剧吗？',
      a: '我们的内容团队每日精选300+新内容同步更新，热播剧集通常与电视台和流媒体平台同步上线。无论是正在热映的国产剧、日韩新番、还是海外大片，极速影视都会在第一时间收录上线，让你追剧永不落伍。',
    },
    {
      q: '如何反馈问题或建议？',
      a: '您可以通过页面底部的联系方式或意见反馈入口向我们提交问题和建议。我们的运营团队会在24小时内处理您的反馈。同时欢迎加入极速影视官方QQ群和微信群，与其他追剧爱好者一起交流和互动。',
    },
  ];

  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">关于极速影视，你可能想了解的一切</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-100 border border-background-200/50 rounded-xl overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-200/30 transition-colors"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <h3 className="text-sm font-semibold text-foreground-100 pr-4">{faq.q}</h3>
                <i
                  className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-200 text-lg ${
                    openIndex === i ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-400 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}